import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import {
  H,
  Flex,
  Text,
  Alert,
  FormErrorTypes,
  AlertsContext,
  Alerts,
} from 'dash-ui';
import Background from 'assets/images/jpg/SignInPageMask.jpg';
import SignInForm from 'pages/authentication/SignInPage/components/SignInForm/SignInForm';
import AuthenticationPageLayout from 'flow-components/AuthenticationPageLayout/AuthenticationPageLayout';

function SignInPage() {
  const { t } = useTranslation('pages', { keyPrefix: 'signInPage' });
  const { t: tAlerts } = useTranslation('common', { keyPrefix: 'alerts' });
  const theme = useTheme();
  const { state } = useContext(AlertsContext);
  return (
    <AuthenticationPageLayout backgroundImgSrc={Background}>
      <Flex flexDirection="column" w={334}>
        <Flex mb={8}>
          {state[Alerts.ResetPasswordEmailsSent] && (
            <Alert type={FormErrorTypes.Valid}>
              {tAlerts`resetPasswordEmailsSent`}
            </Alert>
          )}
          {state[Alerts.PasswordReset] && (
            <Alert type={FormErrorTypes.Valid}>{tAlerts`passwordReset`}</Alert>
          )}
        </Flex>
        <Flex flexDirection="column">
          <H bold sm as={4}>{t`welcomeHeader`}</H>
          <Text color={theme.colors.n70}>{t`welcomeSubHeader`}</Text>
        </Flex>
        <SignInForm />
      </Flex>
    </AuthenticationPageLayout>
  );
}

export default SignInPage;
